import config from 'player/config';
import utils from 'utils/utils';

function getDeviceType() {
    return utils.device.getDeviceType();
}

function getCountryCode(vendor) {
    return (vendor === 'ab' || vendor === 'svd') ? 'se' : 'no';
}

function buildQueryParamsString(params) {
    const queryObject = utils.extend({
        cb: (Math.round(Math.random() * 100000000000))
    }, params);

    return utils.jsonToUrl(queryObject);
}

export default {
    getPtvTag(params) {
        const queryParams = buildQueryParamsString(params);
        return `${config.ads.appnexus.ptv}?${queryParams}`;
    },

    getVmapTag(params) {
        const queryParams = buildQueryParamsString(params);
        return `${config.ads.appnexus.vmap}?${queryParams}`;
    },

    getAstConfig(tagOptions, globalOptions) {
        return utils.extend({}, utils.merge(globalOptions, tagOptions));
    },

    getDefaultParams(stream) {
        const vendor = stream.getVendor();

        return {
            countryCode: getCountryCode(vendor),
            supplyType: `web_${getDeviceType()}`,
            publisherName: vendor,
            slotIds: {
                preroll: 1,
                midroll: 2,
                postroll: 3
            }
        };
    }
};
